import React, { useEffect } from 'react';
import CanvasComponent from '../components/Canvas';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import '../styles/ExportVote.css';
import '../styles/BaseForm.css';
import '../styles/canvas.css';
import fr from '../locales/fr';
import en from '../locales/en';

function ExportDessin({ ws }) {
    const navigate = useNavigate();
    const location = useLocation();
    const browserLang = navigator.language || navigator.userLanguage;
    const language = browserLang.startsWith('fr') ? 'fr' : 'en';
    const translations = language === 'fr' ? fr : en;

    const allowed =
        location.state?.fromMediaSelect ||
        sessionStorage.getItem('canAccessExportDessin');

    useEffect(() => {
        if (allowed) {
            sessionStorage.removeItem('canAccessExportDessin');
        }
    }, [allowed]);

    if (!allowed) {
        return <Navigate to="/mediaSelect" replace />;
    }

    const handleExportSuccess = () => {
        sessionStorage.setItem('canAccessReady', 'true');
        navigate('/Ready', { state: { fromAuthorized: true } });
    };

    return (
        <div className="boxform">
            <CanvasComponent ws={ws} onExportSuccess={handleExportSuccess} translations={translations} />
        </div>
    );
}

export default ExportDessin;
